import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { MomentModule } from 'ngx-moment';
import { NgxGaugeModule } from '../../assets/libs/ngx-gauge';
import { PipesModule } from '../../pipes/pipes.module';
import { DashNiasPage } from './dash-nias';

@NgModule({
  declarations: [DashNiasPage],
  imports: [
    IonicPageModule.forChild(DashNiasPage),
    TranslateModule.forChild(),
    MomentModule,
    PipesModule,
    NgxGaugeModule,
  ],
  entryComponents: [],
})
export class DashNiasPageModule {}



// WEBPACK FOOTER //
// ./src/pages/dash-nias/dash-nias.module.ts